import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

const BackBar = ({ to = '/dashboard', label = 'Dashboard' }) => {
  const navigate = useNavigate();
  return (
    <div className="bg-white/80 backdrop-blur-xl border-b border-slate-200/60 sticky top-0 z-40" style={{ fontFamily: "'IBM Plex Sans', system-ui, sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      <div className="max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-10 flex items-center justify-between h-12">
        <div className="flex items-center gap-4">
          <button onClick={() => navigate(to)} className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-[#0A2540] transition-colors" data-testid="back-button">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
            {label}
          </button>
        </div>
        <Link to="/" className="text-lg font-bold tracking-tight text-[#0A2540]">
          PlanGen<span className="text-blue-600">Consulting</span>
        </Link>
      </div>
    </div>
  );
};

export default BackBar;
